module.exports = __webpack_public_path__ + "c62c3eea77cf3fca51494e8c924adf4d.woff2";